module.exports = __webpack_public_path__ + "img/layer.7f82df72.svg";